/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from 'react'

interface Props {
  refs: any
  handleClickRef: (ref: any) => void
}

const ProductDetailBreadcrumb = ({ refs, handleClickRef }: Props) => {
  const [scrollY, setScrollY] = useState(0)
  const handleScroll = () => {
    setScrollY(document.documentElement.scrollTop)
  }

  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.addEventListener('scroll', handleScroll)
      return () => window.removeEventListener('scroll', handleScroll)
    }
  })
  return (
    <>
      {scrollY > 25 && (
        <div
          className={`linkSections h-[32px] bg-white shadow items-center justify-around sticky left-0 top-[48px] z-[60] flex  w-full max-w-[440px] flex-wrap`}
        >
          <div
            className={`item text-sm`}
            onClick={() => handleClickRef(refs.outStandingFeatureRef)}
          >
            <div
              className={`link-section relative min-w-[90px] text-center cursor-pointer`}
              data-name={'#outStandingFeature'}
            >
              Điểm nổi bật
            </div>
          </div>

          <div
            className={`item text-sm`}
            onClick={() => handleClickRef(refs.descRef)}
          >
            <div
              className={`link-section relative min-w-[90px] text-center cursor-pointer`}
              data-name={'#description'}
            >
              Mô tả
            </div>
          </div>
          <div
            className={`item text-sm`}
            onClick={() => handleClickRef(refs.specRef)}
          >
            <div
              className={`link-section relative min-w-[90px] text-center cursor-pointer`}
              data-name={'#spec'}
            >
              Thông số
            </div>
          </div>
          <div
            className={`item text-sm`}
            onClick={() => handleClickRef(refs.reviewRef)}
          >
            <div
              className={`link-section relative min-w-[90px] text-center cursor-pointer`}
              data-name={'#review'}
            >
              Đánh giá
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default ProductDetailBreadcrumb
